<template>
  <div class="container">
    <headerNavbar title="体检须知"></headerNavbar>
    <div class="wrapper">
      <h2>体检须知</h2>
      <!-- <pre>{{info}}</pre> -->
      <p v-html="noticeInfo"></p>
    </div>
  </div>
</template>
<style lang="less" scoped>
  .container {
    min-height: 100vh;
    background: #fff;
    padding: 0 24px;

    .wrapper {
      h2 {
        font-size: 20px;
        font-weight: 500;
        line-height: 80px;
      }

      p {
        line-height: 24px;
      }

      pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }
</style>

<script>
  import headerNavbar from '../components/headerNavbar'
  import {
    getHospital
  } from '../../api/hospital'
  export default {
    components: {
      headerNavbar
    },
    data() {
      return {
        noticeInfo: "",
      };
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1);
      }
    },
    async mounted() {
      let hospId = this.$route.query.hospid;
      let res = await getHospital(hospId);
      this.noticeInfo = res.data.notice;
    },

  };
</script>